<template>
  <div>
    <div class="listing-type-one d-xl-flex flex-wrap justify-content-start">
      <div :class="class1"></div>
      <div class="one-right ml-4">
        <ul class="nostyle ul-button d-flex justify-content-center">
          <li>
            <button
              class="btn btn-primary btn-rounded"
              @click="showCreateUserModal"
              style="font-size: 14px;"
            >
              アカウント新規追加
            </button>
          </li>
        </ul>
      </div>
      <CreateUser
        v-if="showCreateUserPopup"
        :isEditing="false"
        @hideModal="hideModal"
      />
    </div>
    <!-- ends listing-type-one -->
  </div>
</template>

<script>
import CreateUser from './CreateUser.vue';
export default {
  name: 'UserBar',
  components: { CreateUser },
  data() {
    return {
      class1:
        'one-left d-xl-flex align-items-center justify-content-center justify-content-md-start',
      showCreateUserPopup: false,
    };
  },
  computed: {},
  methods: {
    showCreateUserModal() {
      this.showCreateUserPopup = true;
    },
    hideModal() {
      this.showCreateUserPopup = false;
    },
  },
};
</script>
